import { BlockType } from '@uno/common-cms';
export var isBlockUnstyledAndEmpty = function isBlockUnstyledAndEmpty(block) {
  return (block === null || block === void 0 ? void 0 : block.getType()) === BlockType.UNSTYLED && block.getText() === '';
};
export default isBlockUnstyledAndEmpty;